import * as React from "react"
import { Box, Grid, Typography } from "@mui/material"
import { ImageSeeker } from "@ui-seeker/core"

import { MoreLessInfo } from "@components"
import { useBuildExternalURL } from "@hooks"
import ProductPagesDetailsModalImagesContent from "./ImagesBlock"
import ProductPagesDetailsModalRatingContent from "./RatingBlock"
import ProductPagesModalSkuBlock from "./SkuBlock"
import ProductPagesDetailsModalVideosContent from "./VideosBlock"


export default function ProductPagesDetailsModalContent({ data }) {
	const siteID = data.siteID
	const productID = data.productID
	const date = data.date
	const skuName = data.skuName
	const skuID = data.skuID

	const { imageURL } = useBuildExternalURL({ imageData: { skuID, siteID, productID, date } })
	const description = data.description
	const richContentText = data.richContentText
	const supertitle = data.supertitle
	const productTitle = data.productTitle
	const subtitle = data.subtitle
	const brand = data.brand

	return <Grid container spacing={3}>
		<Grid item xs={12}>
			<ProductPagesModalSkuBlock
				date={date}
				company={data.company}
				category={data.category}
				productID={productID}
				siteID={siteID}
				sku={skuName}
				brand={data.brand}
				country={data.country}
				retailer={data.retailer}
				siteURL={data.siteURL}
				ean={data.ean}
				supertitle={supertitle}
				productTitle={productTitle}
				subtitle={subtitle}
				brandRaw={brand}
			/>
		</Grid>
		<Grid item xs={12}>
			<Box sx={{ textAlign: 'center' }}>
				<ImageSeeker src={imageURL}   maxWidth="250px" width="auto" height='auto' maxHeight='600px' />
			</Box>
		</Grid>

		<Grid item xs={12}>
			<ProductPagesDetailsModalImagesContent images={data.images} data={data} />
		</Grid>

		<Grid item xs={12}>
			<ProductPagesDetailsModalVideosContent videos={data.videos} data={data} />
		</Grid>

		<Grid item xs={12} sx={{"&:hover div": { color: "primary.main" }}}>
			<ProductPagesDetailsModalRatingContent
				lastReview={data.lastReview}
				reviews={data.reviews}
				rating={data.rating}
				data={data}
			/>
		</Grid>

		<Grid item xs={12}>
			<Box>
				<Box className="infoContainer" sx={{ mt: 2 }}>
					<Typography variant="subtitle2" className="label" sx={{ display: "inline", fontSize: "0.8rem" }}>
						Description:
					</Typography>
					<Box className="value" sx={{ display: "inline", fontSize: "0.8rem" }}>
						{ !description && "N/A" }
						{ !!description && <MoreLessInfo>
							{description}
						</MoreLessInfo> }
					</Box>
				</Box>
				<Box className="infoContainer" sx={{ mt: 2 }}>
					<Typography variant="subtitle2" className="label" sx={{ display: "inline", fontSize: "0.8rem" }}>
						Rich Content:
					</Typography>
					<Box className="value" sx={{ display: "inline", fontSize: "0.8rem" }}>
						{ !richContentText && "N/A" }
						{ !!richContentText && <MoreLessInfo>
							{richContentText}
						</MoreLessInfo> }
						{!!data.imagesRichContent?.length && <Box sx={{ mt: 1 }}>
							<ProductPagesDetailsModalImagesContent
								images={data.imagesRichContent}
								data={data}
								showTitle={false}
								isRichContent={true}
							/>
						</Box>}
					</Box>
				</Box>
			</Box>
		</Grid>
	</Grid>
}